import React from "react";
import { Button } from "reactstrap";
import "./index.scss";
const LoadMore = ({ className = '', label = 'View More', loading = false, __handlePageChange, page }) => {
	const pageChange = () => {
		__handlePageChange(page + 1);
	};

	return (
		<>
			<div className={`load-more-blc text-center ${className} ${loading ? 'loading' : ''}`}>
				<Button onClick={pageChange} color="link">
					{label}
					<span className="icon">
						{
							loading ? <img className="img-fluid" src={require('../../../assets/img/icons/spinner.gif')} alt="Spinner" /> :
								<svg xmlns="http://www.w3.org/2000/svg" width="8.22" height="12.807" viewBox="0 0 8.22 12.807">
									<path id="up-arrow" d="M115.72,10.7l-4.11,4.11L107.5,10.7l.867-.867L111,12.468V2h1.226V12.453l2.623-2.623Z" transform="translate(-107.5 -2)" fill="#8392a5" />
								</svg>
						}

					</span>
				</Button>
			</div>
		</>
	);

}

export default LoadMore;